export default __webpack_public_path__ + "static/media/id-billing-logotype-d.743b022c.svg";